<fieldset class="border rounded-3 p-3">
    <legend class="subtitle-4 float-none w-auto px-3">
        Assessment limited to hydrostatic head loading; supplemental loads (e.g., wind, seismic, and other external loads) are not included.
    </legend>

    <div *ngIf="validationList.length > 0">
        <validation [ValidationList]="validationList" [ValidationLabel]="validationListLabel"></validation>
        <br />
    </div>

    <div class="container">
        <form [formGroup]="mfhForm">
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="selectedComponentType">Component type:</label>
                </div>
                <div class="col-sm-4">
                    <select id="selectedComponentType" formControlName="selectedComponentType"
                        class="form-control form-control-sm" name="selectedComponentType"
                        (change)="onComponentTypeChange($event.target.value)">
                        <option value="" disabled selected hidden>Select Type</option>
                        <option *ngFor="let data of ComponentTypeData" [value]="data.value">
                            {{ data.text }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="insideDiameter_MFH">Original inside diameter, D&nbsp;<span
                            *ngIf="this.intUnit === 0">(ft)</span><span
                            *ngIf="this.intUnit === 1">(m)</span>:</label>
                </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="insideDiameter_MFH"
                            formControlName="insideDiameter_MFH" name="insideDiameter_MFH" class="form-control form-control-sm"
                            (change)="onInsideDiameterChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="nominalThickness_MFH">Original nominal thickness, tnom&nbsp;<span
                                *ngIf="this.intUnit === 0">(inch)</span><span
                                *ngIf="this.intUnit === 1">(mm)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="nominalThickness_MFH"
                            formControlName="nominalThickness_MFH" name="nominalThickness_MFH" class="form-control form-control-sm"
                            (change)="onNominalThicknessChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="internalLoss_MFH">Current uniform metal loss (internal), LOSSi&nbsp;<span
                                *ngIf="this.intUnit === 0">(inch)</span><span
                                *ngIf="this.intUnit === 1">(mm)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="internalLoss_MFH"
                            formControlName="internalLoss_MFH" name="internalLoss_MFH" class="form-control form-control-sm"
                            (change)="onInternalLossChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="externalLoss_MFH">Current uniform metal loss (external), LOSSe&nbsp;<span
                                *ngIf="this.intUnit === 0">(inch)</span><span
                                *ngIf="this.intUnit === 1">(mm)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="externalLoss_MFH"
                            formControlName="externalLoss_MFH" name="externalLoss_MFH" class="form-control form-control-sm"
                            (change)="onExternalLossChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="internalFca_MFH">Future corrosion allowance (internal), FCAi&nbsp;<span
                                *ngIf="this.intUnit === 0">(inch)</span><span
                                *ngIf="this.intUnit === 1">(mm)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="internalFca_MFH"
                            formControlName="internalFca_MFH" name="internalFca_MFH" class="form-control form-control-sm"
                            (change)="onInternalFcaChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="externalFca_MFH">Future corrosion allowance (external), FCAe&nbsp;<span
                                *ngIf="this.intUnit === 0">(inch)</span><span
                                *ngIf="this.intUnit === 1">(mm)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="externalFca_MFH"
                            formControlName="externalFca_MFH" name="externalFca_MFH" class="form-control form-control-sm"
                            (change)="onExternalFcaChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="allowableStress_MFH">Allowable stress for the shell course under assessment according to API 653,
                            S&nbsp;<span *ngIf="this.intUnit === 0">(psi)</span><span
                                *ngIf="this.intUnit === 1">(MPa)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="allowableStress_MFH"
                            formControlName="allowableStress_MFH" name="allowableStress_MFH" class="form-control form-control-sm"
                            (change)="onAllowableStressChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="circumferentialWeldJointEfficiency_MFH">Weld joint efficiency, E</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="circumferentialWeldJointEfficiency_MFH"
                            formControlName="circumferentialWeldJointEfficiency_MFH" name="circumferentialWeldJointEfficiency_MFH" class="form-control form-control-sm"
                            (change)="onCircumferentialWeldJointEfficiencyChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="designLiquidHead_MFH">Tank maximum design filling height, H_L&nbsp;<span
                                *ngIf="this.intUnit === 0">(ft)</span><span
                                *ngIf="this.intUnit === 1">(m)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="designLiquidHead_MFH"
                            formControlName="designLiquidHead_MFH" name="designLiquidHead_MFH" class="form-control form-control-sm"
                            (change)="onDesignLiquidHeadChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="specificGravity_MFH">Specific gravity, s_g:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="specificGravity_MFH"
                            formControlName="specificGravity_MFH" name="specificGravity_MFH" class="form-control form-control-sm"
                            (change)="onSpecificGravityChanged($event.target.value)" min="0" />
                    </div>
                </div>

                <!-- <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="allowableRemainingStrengthFactor_MFH">Allowable Remaining Strength Factor, RSFa (default = 0.9):</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" appRestrictInput id="allowableRemainingStrengthFactor_MFH" formControlName="allowableRemainingStrengthFactor_MFH"
                            name="allowableRemainingStrengthFactor_MFH" class="form-control form-control-sm"
                            (change)="onAllowableRemainingStrengthFactorChanged($event.target.value)" min="0" />
                    </div>
                </div> -->
                <div class="form-group row align-items-center">
                    <div class="col-sm-8 align-self-center">
                        <label for="shellCourseBottomHeight_MFH">Distance from the 
                            lower edge of the shell course under assessment to the tank floor, H_c&nbsp;<span
                                *ngIf="this.intUnit === 0">(ft)</span><span
                                *ngIf="this.intUnit === 1">(m)</span>:</label>
                    </div>
                    <div class="col-sm-4">
                        <input type="number" labelDisable appRestrictInput id="shellCourseBottomHeight_MFH"
                            formControlName="shellCourseBottomHeight_MFH" name="shellCourseBottomHeight_MFH" class="form-control form-control-sm"
                            (change)="onShellCourseBottomHeightChanged($event.target.value)" min="0" />
                    </div>
                </div>
        </form>
    </div>
</fieldset>